import { jsx as t, jsxs as c, Fragment as d } from "react/jsx-runtime";
import '../../assets/CustomerLeadCard.css';const l = "#ffffff", n = "#396e75", s = "#e5fdff", m = "#546223", i = "#f0fae5", g = "#a65523", u = "#fff1e8", _ = "#7f3e3e", h = "#ffe2e2", k = "#62625a", z = "#f8f8e7", C = "#38539a", V = "#707070", b = "#c8f8d1", v = "#87c9c8", f = "#5291b1", w = "rgba(82, 145, 177, 0.1019607843)", B = "#445685", p = "#181d61", y = "rgba(24, 29, 97, 0.1019607843)", N = "#5969d6", $ = "#ea999d", G = "#b6577e", O = "rgba(182, 87, 126, 0.1019607843)", R = "#7e3e80", W = "#1e247f", Y = "rgba(30, 36, 127, 0.1019607843)", x = "#da7600", j = "#107f47", A = "#d91734", P = "_html_37cvm_38", r = {
  amwayWhite: l,
  darkBlue: n,
  lightBlue: s,
  darkGreen: m,
  lightGreen: i,
  darkOrange: g,
  lightOrange: u,
  darkRed: _,
  lightRed: h,
  darkYellow: k,
  lightYellow: z,
  darkPurple: C,
  darkGrayOnWhite: V,
  dataVizColor1: b,
  dataVizColor2: v,
  dataVizColor3: f,
  dataVizColor3Background: w,
  dataVizColor4: B,
  dataVizColor5: p,
  dataVizColor5Background: y,
  dataVizColor6: N,
  dataVizColor7: $,
  dataVizColor8: G,
  dataVizColor8Background: O,
  dataVizColor9: R,
  dataVizColor10: W,
  dataVizColor10Background: Y,
  dataVizAlertOrange: x,
  dataVizSuccessGreen: j,
  dataVizWarningRed: A,
  "no-visible": "_no-visible_37cvm_34",
  html: P,
  "customer-lead-card-container": "_customer-lead-card-container_37cvm_72",
  "customer-lead-card-wrapper": "_customer-lead-card-wrapper_37cvm_77",
  "customer-lead-card-title": "_customer-lead-card-title_37cvm_80",
  "customer-lead-card-tag-container": "_customer-lead-card-tag-container_37cvm_86",
  "customer-card-tag-name-color-dark-blue": "_customer-card-tag-name-color-dark-blue_37cvm_97",
  "customer-card-tag-name-color-dark-green": "_customer-card-tag-name-color-dark-green_37cvm_100",
  "customer-card-tag-name-color-dark-orange": "_customer-card-tag-name-color-dark-orange_37cvm_103",
  "customer-card-tag-name-color-dark-red": "_customer-card-tag-name-color-dark-red_37cvm_106",
  "customer-card-tag-name-color-dark-yellow": "_customer-card-tag-name-color-dark-yellow_37cvm_109",
  "customer-card-tag-name-color-dark-purple": "_customer-card-tag-name-color-dark-purple_37cvm_112",
  "customer-card-tag-bg-color-white": "_customer-card-tag-bg-color-white_37cvm_115",
  "customer-card-tag-bg-color-light-purple": "_customer-card-tag-bg-color-light-purple_37cvm_118",
  "customer-card-tag-bg-color-light-red": "_customer-card-tag-bg-color-light-red_37cvm_121",
  "customer-card-tag-bg-color-light-blue": "_customer-card-tag-bg-color-light-blue_37cvm_124",
  "customer-card-tag-bg-color-light-green": "_customer-card-tag-bg-color-light-green_37cvm_127",
  "customer-card-tag-bg-color-light-orange": "_customer-card-tag-bg-color-light-orange_37cvm_130",
  "customer-card-tag-bg-color-light-yellow": "_customer-card-tag-bg-color-light-yellow_37cvm_133",
  "customer-lead-card-subtitle": "_customer-lead-card-subtitle_37cvm_136"
}, F = (a) => {
  const o = `customer-card-tag-bg-color-${a.tagBackgroundColor || "white"}`, e = `customer-card-tag-name-color-${a.tagNameColor}`;
  return /* @__PURE__ */ t("div", { className: `${r["customer-lead-card-container"]}`, "data-testid": "customer-lead-card-container-testid", "data-pod-name": "commerce", children: /* @__PURE__ */ c("div", { className: `${r["customer-lead-card-wrapper"]}`, children: [
    a.tagName && /* @__PURE__ */ t(
      "div",
      {
        className: `${r["customer-lead-card-tag-container"]} ${r[o]} ${r[e]}`,
        "data-testid": "customer-lead-card-tag-testid",
        "data-pod-name": "commerce",
        children: a.tagName
      }
    ),
    /* @__PURE__ */ t("div", { className: `${r["customer-lead-card-title"]}`, "data-testid": "customer-lead-card-title-testid", "data-pod-name": "commerce", children: a.title }),
    /* @__PURE__ */ t("div", { className: `${r["customer-lead-card-subtitle"]}`, "data-testid": "customer-lead-card-subtitle-testid", "data-pod-name": "commerce", children: a.description && /* @__PURE__ */ t(d, { children: a.description }) })
  ] }) });
};
export {
  F as default
};
//# sourceMappingURL=CustomerLeadCard.js.map
